import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-lista',
  templateUrl: './lista.component.html',
  styleUrls: ['./lista.component.css']
})
export class ListaComponent implements OnInit {


  constructor(private fb: UntypedFormBuilder) { }

  @Input() opcoes: Array<any> = [];
  @Input() formulario: UntypedFormGroup;
  @Input() nomeControle: string;
  @Input() classe: string;
  @Input() descricao: string = '';
  @Input() desabilitado: boolean;
  @Input() textoAjuda: string;

  ngOnInit(): void {
    // Inicializa o FormControl se necessário
    if (this.formulario && this.nomeControle && !this.formulario.controls[this.nomeControle]) {
      this.formulario.addControl(this.nomeControle, new UntypedFormControl(null));
    }
  }
  onSelectionChange(event: any) {
    const selectedValue = event?.value;
    this.formulario?.get(this.nomeControle)?.setValue(selectedValue);
  }

}
